import React from "react";
import {t} from "i18next";

export const StatusEnum = {
    approved: "approved",
    draft: "draft",
    pending: "pending",
    doing: "doing",
    actived: "actived",
    inactive: "inactive",
    inactived: "inactived",
    denied: "denied",
    return: "return"
}
export const DG_Format_Status = (status) => {
    const initStyle = "text-center text-[14px] py-[2px] px-[6px] rounded-xl font-[500]"

    switch (status) {
        case StatusEnum.draft:
            return <span className={`bg-[#00000005] text-[#000000E0] ${initStyle}`} >
                {t("common.draft")}
            </span>
        case StatusEnum.pending:
            return <span className={`bg-[#FFFBE6] text-[#FAAD14] ${initStyle}`} >
                {t("common.pending")}
            </span>
        case StatusEnum.doing:
            return <span className={`bg-[#DFF7E8] text-[#12B76A] ${initStyle}`} >
                {t("common.doing")}
            </span>
        case StatusEnum.approved:
            return <span className={`bg-[#E6FFFB] text-[#13C2C2] ${initStyle}`} >
                {t("common.approved")}
            </span>
        case StatusEnum.actived:
            return <span className={`bg-[#dff7e8] text-[#12b76a] ${initStyle}`} >
                {t("common.actived")}
            </span>
        case StatusEnum.inactive:
            return <span className={`bg-[#F2F4F7] text-[#4C5768] ${initStyle}`} >
                {t("common.inactive")}
            </span>
        case StatusEnum.inactived:
            return <span className={`bg-[#4c5768] text-[#f2f4f7] ${initStyle}`} >
                {t("common.inactived")}
            </span>
        case StatusEnum.denied:
            return <span className={`bg-[#FFF2F0] text-[#FF3838] ${initStyle}`} >
                {t("common.denied")}
            </span>
        default:
            break;
    }
}